module.exports = __webpack_public_path__ + "static/img/counp5.7a791752.png";